var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12851_45219",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12851_45219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.4 17.0001L12 13.4001L15.6 17.0001L17 15.6001L13.4 12.0001L17 8.40006L15.6 7.00006L12 10.6001L8.4 7.00006L7 8.40006L10.6 12.0001L7 15.6001L8.4 17.0001ZM12 22.0001C10.6167 22.0001 9.31667 21.7376 8.1 21.2126C6.88333 20.6876 5.825 19.9751 4.925 19.0751C4.025 18.1751 3.3125 17.1167 2.7875 15.9001C2.2625 14.6834 2 13.3834 2 12.0001C2 10.6167 2.2625 9.31673 2.7875 8.10006C3.3125 6.88339 4.025 5.82506 4.925 4.92506C5.825 4.02506 6.88333 3.31256 8.1 2.78756C9.31667 2.26256 10.6167 2.00006 12 2.00006C13.3833 2.00006 14.6833 2.26256 15.9 2.78756C17.1167 3.31256 18.175 4.02506 19.075 4.92506C19.975 5.82506 20.6875 6.88339 21.2125 8.10006C21.7375 9.31673 22 10.6167 22 12.0001C22 13.3834 21.7375 14.6834 21.2125 15.9001C20.6875 17.1167 19.975 18.1751 19.075 19.0751C18.175 19.9751 17.1167 20.6876 15.9 21.2126C14.6833 21.7376 13.3833 22.0001 12 22.0001ZM12 20.0001C14.2333 20.0001 16.125 19.2251 17.675 17.6751C19.225 16.1251 20 14.2334 20 12.0001C20 9.76673 19.225 7.87506 17.675 6.32506C16.125 4.77506 14.2333 4.00006 12 4.00006C9.76667 4.00006 7.875 4.77506 6.325 6.32506C4.775 7.87506 4 9.76673 4 12.0001C4 14.2334 4.775 16.1251 6.325 17.6751C7.875 19.2251 9.76667 20.0001 12 20.0001Z",
    fill: "#FF0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.3c2ae0d4082df8107b4009cb9ccf371f.svg";
export { ForwardRef as ReactComponent };